export default __webpack_public_path__ + "static/media/faq.7fe7d832.png";